import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[chain]/token/[tokenSymbol]/detail.tsx");
